<template>
	<panel class="mt-16" style="height: 100%">
		<div class="flex-row-align-center">
			<div class="color-gy-9 font-h3-medium">{{ label }}</div>
			<div class="color-gy-7 fz-12 ml-8" v-if="$isPlatOr(['Dy', 'kS'])">今日/每日联系方式剩余获取次数</div>
		</div>
		<div class="clueSeas-shopInfo-wrapper">
			<div class="flex-row flex-just-between clueSeas-shopInfo" v-for="item in allianceShopList" :key="item.shopId">
				<div class="flex-1">
					<div class="flex-row-align-center">
						<platform-icon :platformId="item.platformId" />
						<div class="font-h6-regular line-ellipsis-1 flex-1 ml-4">{{ item.shopName }}</div>
					</div>
					<div class="color-gy-7 fz-12 mt-4">店铺ID：{{ item.shopId }}</div>
				</div>
				<div class="ml-32 text-align-right" v-if="$isPlatOr(['Dy', 'kS'])">
					<div class="Barlow-SemiBold fz-14">{{ item.todayContactNum }}/{{ item.dayContactNum }}</div>
					<div class="color-gy-7 mt-4 fz-12">次数</div>
				</div>
			</div>
		</div>
		<Empty size="120" v-if="!allianceShopList.length">
			<template #desc>
				<p class="font-h6-regular yx-color-text-placeholder">暂无数据</p>
			</template>
		</Empty>
	</panel>
</template>

<script>
import { getAllianceShopList, getKsShopList } from '@/api/talentCRM';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
	},
	data() {
		return {
			allianceShopList: [],
		};
	},
	components: {},
	computed: {
		label({ platformId }) {
			const temPF_name = {
				[dataMap.PLATFORM_DY.value]: '抖音团长账号信息',
				[dataMap.PLATFORM_KS.value]: '快手团长账号信息',
			};
			return temPF_name[platformId] || '';
		},
	},
	mounted() {
		this.getAllianceShopList();
	},
	methods: {
		async getAllianceShopList() {
			let api = {
				[dataMap.PLATFORM_DY.value]: getAllianceShopList,
				[dataMap.PLATFORM_KS.value]: getKsShopList,
			};
			const data = await api[this.platformId]({ platformId: this.platformId });
			this.allianceShopList = data;
		},
	},
};
</script>

<style lang="less">
.clueSeas-shopInfo {
	border: 1px solid @color-gy3;
	border-radius: 8px;
	padding: 16px 20px 16px 20px;
}
.clueSeas-shopInfo-wrapper {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-gap: 12px;
	margin-top: 16px;
}
</style>
